var _circle, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsightsGenieMinimized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "url(#paint0_linear_137_65517)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_137_65517)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.43 61.4189C63.43 61.4189 67.5012 62.7442 71.1492 60.8242C74.7973 58.9047 74.1896 51.7684 69.5782 51.2368C64.9668 50.7052 63.8832 63.3533 52.5402 67.1709C34.8693 73.1179 24.5954 44.1718 10.4795 50.7513C12.9104 47.626 15.6281 46.8632 18.394 47.1867C29.7016 48.5087 37.0163 61.4753 48.5637 61.0257C59.1713 60.6128 62.5293 51.1148 68.3537 49.2533C74.178 47.3911 80.0387 56.1877 76.391 61.6616C72.743 67.1363 63.43 61.4193 63.43 61.4193V61.4189ZM46.4253 70.2147C42.673 70.2147 39.3838 72.0642 37.5454 74.8389C40.2013 74.1346 43.221 73.7357 46.4253 73.7357C49.6296 73.7357 52.6502 74.1346 55.3057 74.8389C53.468 72.0642 50.178 70.2147 46.4253 70.2147Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4738 18.7539C56.3555 18.1312 56.0473 17.5221 55.5821 16.993C55.5043 16.9044 55.4186 16.8175 55.3304 16.7334C54.9332 16.3555 54.4511 16.0481 53.9378 15.8441C53.3057 15.5911 52.618 15.488 51.9526 15.5478C51.2514 15.6117 50.6094 15.842 50.0956 16.2117C50.0153 16.2685 49.9869 16.3749 50.0264 16.4647C50.0375 16.4927 50.0528 16.5162 50.073 16.5348C50.1216 16.5809 50.1892 16.6015 50.2571 16.5879C50.8888 16.4692 51.4462 16.4284 51.9642 16.4659C52.5089 16.5026 53.0412 16.6258 53.5467 16.8257C54.0527 17.0284 54.5216 17.3062 54.9423 17.654C55.0407 17.7364 55.1396 17.8242 55.2356 17.9157C55.5311 18.1963 55.8125 18.5223 56.0976 18.9179C56.1054 18.9282 56.1145 18.9369 56.1235 18.9455C56.1829 19.002 56.2727 19.0205 56.3506 18.9871C56.4404 18.9476 56.4911 18.8512 56.4738 18.7535V18.7539ZM55.3823 17.7657C55.5018 17.879 55.618 17.9969 55.7296 18.1217C55.6172 17.9977 55.5018 17.8794 55.3823 17.7657ZM55.7342 18.1263C55.8458 18.2499 55.953 18.3777 56.0576 18.5149C55.9534 18.381 55.8446 18.2511 55.7342 18.1263Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6172 14.7854C55.7816 14.8897 55.9422 15.0046 56.0951 15.1241C55.9406 15.0034 55.7803 14.8913 55.6172 14.7854Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3885 15.3721C56.2929 15.2868 56.1961 15.2031 56.0951 15.124C56.1948 15.2036 56.2925 15.2868 56.3885 15.3721Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7766 15.7457C56.6852 15.6484 56.5887 15.5557 56.4911 15.4646C56.5063 15.4786 56.5224 15.4922 56.5372 15.5062C56.618 15.5829 56.6988 15.6628 56.7766 15.7452V15.7457Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5372 15.5066C56.522 15.4921 56.5063 15.479 56.4911 15.465C56.5887 15.556 56.6851 15.6487 56.7766 15.746C56.6987 15.6632 56.618 15.5836 56.5372 15.507V15.5066ZM56.0951 15.1241C56.1961 15.2033 56.2929 15.2873 56.3885 15.3722C56.2925 15.2869 56.1948 15.2037 56.0951 15.1241ZM56.0951 15.1241C55.9418 15.0046 55.7816 14.8897 55.6172 14.7854C55.7803 14.8913 55.9406 15.003 56.0951 15.1241Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2854 17.9548C58.0423 17.1034 57.5731 16.2891 56.9286 15.6009C56.8491 15.5169 56.7655 15.434 56.6818 15.3545C56.1017 14.8031 55.4009 14.3539 54.6506 14.0547C53.7861 13.7111 52.8475 13.5578 51.9337 13.6105C50.993 13.667 50.0932 13.9336 49.3305 14.3824C49.2399 14.438 49.2024 14.5505 49.2436 14.6478C49.2559 14.6741 49.2716 14.6976 49.293 14.7178C49.3449 14.7668 49.4211 14.7875 49.4949 14.7677C50.3342 14.5278 51.1591 14.4195 51.9444 14.4471C52.7536 14.4743 53.5451 14.6383 54.2987 14.9403C55.0523 15.2424 55.7404 15.6648 56.3456 16.2022C56.4078 16.2586 56.4717 16.3163 56.5327 16.3744C57.0457 16.8624 57.508 17.4496 57.9035 18.1189C57.9142 18.1349 57.9266 18.1526 57.9402 18.1654C57.9995 18.2219 58.0877 18.2388 58.1684 18.2058C58.264 18.1634 58.3163 18.0566 58.2854 17.9548ZM56.0951 15.1241C55.9406 15.0034 55.7803 14.8913 55.6172 14.7854C55.7816 14.8897 55.9423 15.0046 56.0951 15.1241Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0992 17.1628C59.7329 16.0811 59.1025 15.0611 58.2756 14.2114C58.1977 14.1314 58.1153 14.0502 58.0333 13.9724C57.2752 13.2516 56.3522 12.6611 55.363 12.2683C54.2703 11.8323 53.0762 11.6275 51.911 11.6766C50.7281 11.7227 49.5691 12.0301 48.5588 12.5622C48.4607 12.6137 48.4191 12.7307 48.4632 12.8304C48.4743 12.8585 48.4912 12.8803 48.511 12.8993C48.5658 12.9512 48.6465 12.973 48.7232 12.9475C49.7854 12.5861 50.8628 12.4105 51.9225 12.4266C52.9897 12.4414 54.0441 12.6524 55.0498 13.0521C56.0481 13.4506 56.9571 14.0218 57.751 14.7508L57.8545 14.8493C58.5883 15.547 59.2158 16.3815 59.7152 17.3289C59.7263 17.3507 59.7386 17.3685 59.7551 17.3845C59.8145 17.441 59.9043 17.4595 59.9834 17.4249C60.0835 17.3808 60.1354 17.2679 60.0988 17.1632L60.0992 17.1628ZM58.2055 14.9058C58.2677 14.9688 58.3316 15.0298 58.3917 15.0945C58.3312 15.0298 58.2677 14.9684 58.2055 14.9058Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8021 16.6427C61.7213 16.6761 61.6331 16.6588 61.5738 16.6023C61.5557 16.585 61.54 16.5644 61.5293 16.5426C60.9339 15.3211 60.1486 14.2443 59.1989 13.341L59.1594 13.3035C58.6497 12.8275 58.1178 12.4142 57.5784 12.0758C57.0152 11.714 56.4173 11.4095 55.8022 11.1667C55.1928 10.9207 54.5488 10.7316 53.8859 10.603C53.2616 10.479 52.5913 10.4126 51.8974 10.4081C50.5674 10.4015 49.239 10.6463 47.9498 11.1276C47.8703 11.1564 47.7867 11.1375 47.7302 11.0839C47.7088 11.0637 47.6935 11.0402 47.6808 11.0139C47.6367 10.9108 47.6808 10.7909 47.7825 10.7423C49.0388 10.1278 50.4599 9.78292 51.8867 9.73924C52.5727 9.71616 53.2888 9.76767 54.0198 9.89501C54.705 10.0158 55.3963 10.2123 56.0778 10.4806C56.749 10.7505 57.3872 11.0851 57.9735 11.4717C58.4981 11.8195 58.9785 12.2011 59.402 12.6037C59.4783 12.6763 59.5528 12.75 59.6245 12.8238C60.634 13.8388 61.4255 15.0668 61.915 16.3757C61.9549 16.4803 61.9059 16.599 61.8029 16.6431L61.8021 16.6427Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.622 15.8597C63.5412 15.896 63.4502 15.8791 63.3892 15.821C63.3723 15.8049 63.357 15.7847 63.3447 15.7612L63.0785 15.2181C63.0427 15.1493 63.0035 15.0805 62.9664 15.01C62.9071 14.9016 62.8478 14.7899 62.7905 14.689C62.7518 14.6259 62.7159 14.5629 62.6772 14.5002C62.6105 14.3906 62.5437 14.2777 62.4774 14.1738C62.4358 14.1141 62.3954 14.0527 62.3554 13.9913C62.2829 13.8846 62.2116 13.7766 62.135 13.6715C61.6743 13.0216 61.1478 12.4109 60.566 11.855L60.5433 11.8331C59.4 10.746 58.0209 9.86372 56.5562 9.27977C55.0807 8.6913 53.4623 8.3814 51.8723 8.38923C51.0684 8.39335 50.265 8.47289 49.4846 8.6266C49.356 8.65215 49.2304 8.68058 49.1047 8.70902C49.0338 8.7255 48.9613 8.74075 48.8979 8.756C48.771 8.78896 48.6453 8.82317 48.52 8.85778C48.4492 8.87757 48.38 8.8957 48.3165 8.91342C48.1987 8.94927 48.0792 8.98924 47.9613 9.02798C47.8864 9.0523 47.8109 9.0762 47.7434 9.09886L47.1678 9.31109C47.0899 9.34118 47.0059 9.31975 46.9498 9.26617C46.9284 9.24598 46.9115 9.22126 46.9004 9.19323C46.8563 9.08732 46.9066 8.96699 47.0108 8.92125L47.5753 8.67811C47.5798 8.67646 47.5839 8.67481 47.5872 8.67481L47.7669 8.60805C47.8991 8.55695 48.0334 8.5075 48.1748 8.4597C48.2423 8.43703 48.312 8.41602 48.3795 8.39376C48.5077 8.35338 48.6375 8.31134 48.773 8.27219C48.8422 8.25406 48.9119 8.23593 48.9811 8.2178C49.1109 8.18194 49.2423 8.14733 49.3754 8.11436C50.197 7.92727 51.035 7.8226 51.8653 7.80323C52.6848 7.78262 53.5261 7.84897 54.3712 7.9998C55.1845 8.14733 55.9975 8.38058 56.7914 8.69212C57.5768 9.00944 58.3279 9.39928 59.023 9.85424C59.6575 10.2721 60.2475 10.7374 60.7741 11.2381C60.8425 11.3032 60.9096 11.3699 60.9751 11.435C61.5664 12.0206 62.1028 12.6726 62.5697 13.3773C62.6438 13.4885 62.7135 13.6039 62.7864 13.7197C62.8235 13.7811 62.861 13.8425 62.9026 13.9085C62.971 14.0255 63.0348 14.1446 63.1004 14.2616C63.1346 14.323 63.1687 14.3877 63.2079 14.4565C63.2722 14.5843 63.3348 14.7104 63.3974 14.8365L63.4835 15.0112C63.4835 15.0141 63.4852 15.0186 63.4881 15.0215L63.7295 15.5878C63.7736 15.6908 63.7279 15.8123 63.6236 15.861L63.622 15.8597Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3146 36.5519L52.0519 36.4827C54.5105 36.4827 57.2978 36.0582 58.9426 37.4523C60.5961 38.8551 60.7778 41.5387 59.133 43.1838C56.4927 45.8159 50.7796 42.4132 47.6202 41.1406L36.3151 36.5519H36.3146Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9581 40.8811L40.5128 42.5694C39.2837 43.0458 38.2537 43.5651 37.0415 43.9895C31.2072 46.05 30.0383 38.4831 33.0251 37.1932C33.3885 37.037 33.9599 37.0284 34.6266 37.2884L43.9581 40.8815V40.8811Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.75 33.4872C49.1084 31.6344 49.8702 36.1539 51.6275 34.0497C51.2378 36.0929 47.3775 35.7467 45.75 34.0324C44.1225 35.7467 40.2618 36.0929 39.8721 34.0497C41.6293 36.1535 42.3912 31.634 45.75 33.4872Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9371 33.3919C34.1593 29.2619 37.5177 22.4569 40.383 19.4181C42.5646 17.1149 45.1266 15.115 46.3211 13.4006C50.5196 20.9503 47.1175 22.18 43.3088 24.3356C41.1708 25.5476 38.4007 29.158 40.9371 33.3919ZM47.7409 24.4572C49.3684 23.3751 51.1257 21.903 50.459 19.5739C55.9472 23.4093 57.9554 30.6733 50.7878 32.9852C53.5319 30.2493 50.398 24.7515 47.7409 24.4572Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9472 45.6776C55.9472 45.6776 50.3338 44.3828 45.9581 41.9287C45.9581 41.9287 39.151 45.1221 35.8993 45.9285C35.8993 45.9285 35.0341 54.6638 43.4328 56.9979C51.8315 59.332 57.7066 53.8561 62.1041 48.2013C62.1041 48.2013 58.557 51.4127 55.4095 50.5749C52.2621 49.7371 55.9472 45.6772 55.9472 45.6772V45.6776Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.1716 21.2454L36.1156 20.4797L29.1716 19.7141L28.4059 12.77L27.6403 19.7141L20.6962 20.4797L27.6403 21.2454L28.4059 28.1894L29.1716 21.2454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9971 37.7296L22.3373 37.0305L15.9971 36.3314L15.2981 29.9912L14.599 36.3314L8.25876 37.0305L14.599 37.7296L15.2981 44.0698L15.9971 37.7296Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_137_65517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.326 70.9137L29.2509 70.4809L25.326 70.0482L24.8933 66.1233L24.4605 70.0482L20.5356 70.4809L24.4605 70.9137L24.8933 74.8386L25.326 70.9137Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_137_65517",
    x: 2.47946,
    y: 43.1182,
    width: 83.0406,
    height: 43.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_137_65517",
    x: 42.0087,
    y: 11.5312,
    width: 22.4684,
    height: 19.4724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_137_65517",
    x: 47.6172,
    y: 10.7854,
    width: 16.4779,
    height: 16.3386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_137_65517",
    x: 48.0951,
    y: 11.124,
    width: 16.2934,
    height: 16.248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_137_65517",
    x: 48.4911,
    y: 11.4646,
    width: 16.2855,
    height: 16.281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_137_65517",
    x: 47.6172,
    y: 10.7854,
    width: 17.1594,
    height: 16.9607,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_137_65517",
    x: 41.2269,
    y: 9.60034,
    width: 25.0674,
    height: 20.6223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_137_65517",
    x: 40.4456,
    y: 7.66943,
    width: 27.6649,
    height: 21.7729,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_137_65517",
    x: 39.6637,
    y: 5.73389,
    width: 30.2651,
    height: 22.9258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_137_65517",
    x: 38.8844,
    y: 3.79956,
    width: 32.8619,
    height: 24.0793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_137_65517",
    x: 28.3146,
    y: 32.4219,
    width: 39.9639,
    height: 23.7351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_137_65517",
    x: 23.438,
    y: 33.083,
    width: 28.5201,
    height: 23.26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_137_65517",
    x: 31.8721,
    y: 29.03,
    width: 27.7555,
    height: 18.4233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_137_65517",
    x: 28.9711,
    y: 9.40063,
    width: 34.4381,
    height: 35.9912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_137_65517",
    x: 27.8741,
    y: 37.9287,
    width: 42.23,
    height: 31.6211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.145098 0 0 0 0 0.192157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_65517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_65517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_137_65517",
    x1: 91.85,
    y1: -27.5,
    x2: 17.05,
    y2: 103.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251363,
    stopColor: "#5299FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18FFC8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_65517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.7674,
    height: 77.7674,
    fill: "white",
    transform: "translate(5.11621 5.11621)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_137_65517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.0786,
    height: 14.0786,
    fill: "white",
    transform: "translate(8.25876 29.9912)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_137_65517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.71532,
    height: 8.71532,
    fill: "white",
    transform: "translate(20.5356 66.1233)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsGenieMinimized);
export default __webpack_public_path__ + "static/media/insights-genie-minimized.8e11c9b1f37465781ffd6a3b5319184e.svg";
export { ForwardRef as ReactComponent };